import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import CustomButtonWithIcon from "../../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";

const CancelationModal = ({ onCancel, onConfirm, isLoading }) => {
  return (
    <div className="add_new_user_mask_container">
      <div className="add_new_user_mask_body" style={{ height: "auto" }}>
        {/* Header */}
        <div className="add_new_user_header" style={{ marginBottom: 10 }}>
          <div className="add_new_user_icon">
            <img src={dentalIcons.crossredIcon} alt="Cancel Icon" />
          </div>
          <p className="_title" style={{ fontSize: 20, fontWeight: 600 }}>
            Cancel Subscription
          </p>
        </div>

        {/* Message */}
        <div style={{ padding: "0 12px 10px 12px" }}>
          <p
            style={{
              color: "#333",
              fontSize: "16px",
              fontWeight: 500,
              fontFamily: "Poppins-Regular",
              marginBottom: 12,
            }}
          >
            Are you sure you want to cancel your subscription?
          </p>

          <p
            style={{
              color: "#646366",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "1.6",
              marginBottom: 16,
            }}
          >
            You will continue to have full access until the end of your current
            billing period. After that, some features will no longer be
            available.
          </p>

          <ul style={{ paddingLeft: 18, margin: 0, listStyle: "disc" }}>
            <li
              style={{
                color: "#646366",
                fontSize: "13px",
                lineHeight: "1.7",
                fontFamily: "Poppins-Regular",
                marginBottom: 6,
              }}
            >
              You will retain full access until your plan expires.
            </li>
            <li
              style={{
                color: "#646366",
                fontSize: "13px",
                lineHeight: "1.7",
                fontFamily: "Poppins-Regular",
                marginBottom: 6,
              }}
            >
              Team members will also retain access during this period.
            </li>
            <li
              style={{
                color: "#646366",
                fontSize: "13px",
                lineHeight: "1.7",
                fontFamily: "Poppins-Regular",
              }}
            >
              After expiration, projects can be viewed but not edited.
            </li>
          </ul>
        </div>
      </div>

      {/* Buttons */}
      <div
        style={{
          marginTop: 20,
          marginBottom: 10,
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          padding: "0 40px",
        }}
      >
        <CustomButtonWithIcon
          title="Keep My Subscription"
          onClick={onCancel}
          width={"50%"}
        />
        <CustomPrimaryButton
          title="Confirm Cancellation"
          onClick={onConfirm}
          isLoading={isLoading}
          width={"50%"}
        />
      </div>
    </div>
  );
};

export default CancelationModal;
